import { queryDictIncome } from '@api/core/dict';

// 按模块的action, reducer整合体
const INCOME_TYPE = 'INCOME_TYPE';

export function getIncomeType() {
  return (dispatch, getState) => {
    const { income_type: type } = getState();
    if (type.length > 0) {
      return dispatch({
        type: INCOME_TYPE,
        data: type,
      });
    }
    return queryDictIncome().then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: INCOME_TYPE,
          data: res.data,
        });
      }
    });
  };
}

export function incomeType(state = [], action) {
  switch (action.type) {
    case INCOME_TYPE:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finance/income_type.js